import React from 'react'

import Text from 'components/common/Text'

import { Container, Filter } from './styles'

import useParticipantsContext from '../../context/useCreateContext'

const Filters = () => {
    const { filters, selectedFilter } = useParticipantsContext()

    return (
        <Container>
            {filters.map(filter => {
                const selected = selectedFilter === filter.key

                return (
                    <Filter
                        key={filter.key}
                        selected={selected}
                        onClick={filter.onClick}
                    >
                        <Text level="3" bold={selected}>
                            {filter.title}
                        </Text>
                    </Filter>
                )
            })}
        </Container>
    )
}

export default Filters
